import Box from '@mui/material/Box';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { BoxProps } from '@mui/material/Box';
import { forwardRef } from 'react';
import useStyles from './AppTabPanel.styles';

type ExtendedTabPanelProps = {
  index: number;
  value: number;
};

type TabPanelProps = Omit<BoxProps, keyof ExtendedTabPanelProps> & ExtendedTabPanelProps;

type TabPanelTypeMap<P = {}, D extends React.ElementType = 'div'> = {
  props: TabPanelProps & P;
  defaultComponent: D;
};
type TabPanelComponent = OverridableComponent<TabPanelTypeMap>;

const TabPanel = forwardRef((props: TabPanelProps, ref: React.ForwardedRef<any>) => {
  const { children, value, index, className, ...rest } = props;
  const { classes, cx } = useStyles();

  return (
    <Box ref={ref} {...rest} className={cx({ [classes.hidden]: value !== index }, className)}>
      {children}
    </Box>
  );
});

export default TabPanel;
